import IconPin from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconPin.js";
import { Address } from "@/lib/Types/Address";
import { City, Country, Region } from "@/lib/Types/location";
import styled from "styled-components";
import TextButton from "../TextButton/TextButton";

const Wrapper = styled.div({
  display: "flex",
  alignItems: "center",
  maxWidth: "100%",
});

const StyledTextButton = styled(TextButton)({
  maxWidth: "100%",
  minWidth: 0,
  "& > svg": {
    flexShrink: 0,
  },
});

const AddressText = styled.span({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
});

interface AddressMapLinkProps {
  address: Address;
  city: City;
  region: Region;
  country: Country;
  onClick?: () => void;
}

const AddressMapLink: React.FC<AddressMapLinkProps> = ({
  address,
  city,
  region,
  country,
  onClick,
}) => {
  return (
    <Wrapper>
      <StyledTextButton onClick={onClick} icon={<IconPin size={16} />}>
        <AddressText>
          {address.street && address.streetNumber && (
            <>
              {address.street}, {address.streetNumber},{" "}
            </>
          )}
          {city.name}, {region.name}, {country.name}
        </AddressText>
      </StyledTextButton>
    </Wrapper>
  );
};

export default AddressMapLink;
